import {action} from 'typesafe-actions';
import {ChangeProductState} from './ChangeProductContext';

export enum ChangeProductActionTypes {
  SET_CHANGE_PRODUCT_DIALOG = 'SET_CHANGE_PRODUCT_DIALOG',
  SET_CHANGE_PRODUCT_PREVIEW_DIALOG = 'SET_CHANGE_PRODUCT_PREVIEW_DIALOG',
  SET_CHANGE_PRODUCT_PREVIEW_IMAGE_DIALOG = 'SET_CHANGE_PRODUCT_PREVIEW_IMAGE_DIALOG',
  SET_ALTERNATIVE_PRODUCTS = 'SET_ALTERNATIVE_PRODUCTS',
  SET_UPGRADE_PRODUCT = 'SET_UPGRADE_PRODUCT',
  SET_CAN_UPGRADE_PRODUCT = 'SET_CAN_UPGRADE_PRODUCT',
  SET_CAN_CHANGE_PRODUCT = 'SET_CAN_CHANGE_PRODUCT',
  RESET_STATE = 'RESET_STATE',
}

export const ChangeProductActions = {
  setChangeProductDialogOpen: (open: boolean) =>
    action(ChangeProductActionTypes.SET_CHANGE_PRODUCT_DIALOG, open),
  setChangeProductDialogPreviewImageDialogOpen: (open: boolean) =>
    action(ChangeProductActionTypes.SET_CHANGE_PRODUCT_PREVIEW_IMAGE_DIALOG, open),
  setChangeProductDialogPreviewDialogOpen: (open: boolean) =>
    action(ChangeProductActionTypes.SET_CHANGE_PRODUCT_PREVIEW_DIALOG, open),
  setAlternativeProducts: (data: any) =>
    action(ChangeProductActionTypes.SET_ALTERNATIVE_PRODUCTS, data),
  setUpgradeProductData: (data: any) => action(ChangeProductActionTypes.SET_UPGRADE_PRODUCT, data),
  setCanUpgradeProduct: (canUpgrade: boolean) =>
    action(ChangeProductActionTypes.SET_CAN_UPGRADE_PRODUCT, canUpgrade),
  setCanChangeProduct: (canChange: boolean) =>
    action(ChangeProductActionTypes.SET_CAN_CHANGE_PRODUCT, canChange),
  resetState: (payload: ChangeProductState) =>
    action(ChangeProductActionTypes.RESET_STATE, payload),
};
